import { inject, Injector } from '@angular/core';
import { ActivityEntityName, Lead } from '@jms/model';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';

/**
 * Opens Lead Manage from the board via the shell inspector.
 *
 * Must run under the board's `runInInjectionContext` so `EntityInspectors` resolves from the shell
 * route providers — it is NOT providedIn root. A root service with `{ optional: true }` always got
 * null and silently no-oped.
 */
export async function navigateToLeadManage(item: Lead): Promise<void> {

  if (!item?._id) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'edit',
    entity: ActivityEntityName.Lead,
    id: item._id,
  });
}
